import { cn } from '../../lib/cn'
import { avatarInitials } from '../../lib/format'

interface AvatarProps {
  name: string | null | undefined
  src?: string | null
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeStyles = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-12 w-12 text-base',
}

/**
 * Flat warm illustration / initials on an ember-tint disc (design-system §5.1).
 * Uses the real Steam avatar when the API provides one; never fabricates art.
 */
export function Avatar({ name, src, size = 'md', className }: AvatarProps) {
  if (src) {
    return (
      <img
        src={src}
        alt=""
        className={cn('shrink-0 rounded-full object-cover ring-1 ring-border-warm', sizeStyles[size], className)}
      />
    )
  }

  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full bg-ember-900/70 font-medium text-ember-300 ring-1 ring-border-warm',
        sizeStyles[size],
        className,
      )}
    >
      {avatarInitials(name)}
    </span>
  )
}
